import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Loading from "../Loading";

const AddFoodItem = ({ setAddFoodItems, addFoodItemLoading, addFoodItemMutate }) => {
  const InitialValue = {
    name: "",
    priority: "",
  };
  const formValidation = Yup.object().shape({
    name: Yup.string().required("Please enter type"),
    priority: Yup.string().required("Please enter priority"),
  });

  const postData = (values) => {
    addFoodItemMutate(values);
  };
  const categoryForm = useFormik({
    initialValues: InitialValue,
    validationSchema: formValidation,
    onSubmit: postData,
  });
  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setAddFoodItems}>
      {addFoodItemLoading ? (
        <Loading />
      ) : (
        <Wrapper>
          <Title>Add Type</Title>
          <form onSubmit={categoryForm.handleSubmit}>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="name">Inventory Type</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter type name"
                    onChange={categoryForm.handleChange}
                    value={categoryForm.values.name}
                  />
                  {categoryForm.touched.name && categoryForm.errors.name ? (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.name}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="priority">Priority</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="priority"
                    placeholder="Enter priority"
                    onChange={(e) => {
                      const { value } = e.target;
                      if (
                        /^\d{0,3}$/.test(value) &&
                        (value === "" ||
                          (Number(value) >= 1 && Number(value) <= 100))
                      ) {
                        categoryForm.handleChange(e);
                      }
                    }}
                    value={categoryForm.values.priority}
                  />
                  {categoryForm.touched.priority &&
                  categoryForm.errors.priority ? (
                    <p className="text-rose-600 text-sm">
                      {categoryForm.errors.priority}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Submit</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default AddFoodItem;
